import React from 'react';
import ShowPatientConsentTable from '../ShowPatientConsentTable';
import Loader from '../Loader';
import Error from '../Error';

const ShowTableOrNoPatientConsent = ({ patientConsentData, showTable, loading, error }) => {
  if (loading) return <Loader />;
  if (error) return <Error />;

  return (
    <div>
      {showTable ? (
        <ShowPatientConsentTable patientConsentData={patientConsentData} />
      ) : (
        <div>No Patient Consent.</div>
      )}
    </div>
  )
}

export default ShowTableOrNoPatientConsent;